import React, { useEffect, useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import sortIcon from "../../../assets/icons/sort.svg";
import filterIcon from "../../../assets/icons/filter.svg";
import { MdCircle, MdOutlineCircle } from "react-icons/md";
import { Input, message, Spin } from "antd";
import ErrorLogout from "../../../helpers/ErrorLogout";
import { getAllGroupBids } from "../../../api/AdminRequest";
import Pagination from "../../common/Pagination";
import ProductCard from "../../common/bid/ProductCard";
import FilterModal from "../../common/bid/FilterModal";
import useAuthStore from "../../../store/authStore";


const { Search } = Input;

const BidList = ({ groupID }) => {
  const { userType } = useAuthStore();
  const [activeTab, setActiveTab] = useState(""); // Update initial state to 'all'
  const [tabFilter, setTabFilter] = useState(""); // Update initial state to 'all'
  // ...
  // const tabs = ['All', 'Live', 'On Hold', 'Cancelled'];
  const tabs = [
    { label: "All", value: "" },
    { label: "Live", value: "live" },
    { label: "Scheduled", value: "scheduled" },
    { label: "Approved", value: "approved" },
    { label: "Expired", value: "expired" },

  ];

  const [isOpen, setIsOpen] = useState(false);
  const [sortBy, setSortBy] = useState({
    key: "1",
    label: "Recently added",
    value: "createdDate:desc",

    icon: <MdCircle size={20} />,
  });
  const [searchValue, setSearchValue] = useState("");
  const [subCategory, setSubCategory] = useState([]);
  const [type, setType] = useState(null);
  const [bidRange, setBidRange] = useState([1000, 10000000]);
  const [searchTerm, setSearchTerm] = useState(searchValue);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loader, setLoader] = useState(false);
  const [bids, setBids] = useState([]);
  const [totalPages, setTotalPages] = useState(5);
  const [limit, setLimit] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [trigger, setTrigger] = useState(false);
  const [showSingleProduct, setShowSingleProduct] = useState(false);
  const [bidID, setBidID] = useState("");

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  // Function to handle button clicks

  const handleLimit = (e) => {
    const selectedValue = parseInt(e.target.value); // Convert value to integer if needed
    setLimit(selectedValue); // Update state with the selected value
    setCurrentPage(1);
  };

  // ------ SORT BY ITEMS--------
  const sortItems = [
    {
      key: "1",
      label: "Recently added",
      value: "createdDate:desc",
      icon:
        sortBy.key === "1" ? (
          <MdCircle
            size={18}
            className="text-blue-500 border w-fit rounded-full border-gray-500"
          />
        ) : (
          <MdOutlineCircle size={18} className="text-gray-500" />
        ),
    },
    {
      key: "2",
      label: "Price-High to Low",
      value: "bidLivePrice:desc",
      icon:
        sortBy.key === "2" ? (
          <MdCircle
            size={18}
            className="text-blue-500 border w-fit rounded-full border-gray-500"
          />
        ) : (
          <MdOutlineCircle size={18} className="text-gray-500" />
        ),
    },
    {
      key: "3",
      label: "Price-Low to High",
      value: "bidLivePrice:asc",
      icon:
        sortBy.key === "3" ? (
          <MdCircle
            size={18}
            className="text-blue-500 border w-fit rounded-full border-gray-500"
          />
        ) : (
          <MdOutlineCircle size={18} className="text-gray-500" />
        ),
    },
    {
      key: "4",
      label: "Most active",
      value: "bidCount:desc",
      icon:
        sortBy.key === "4" ? (
          <MdCircle
            size={18}
            className="text-blue-500 border w-fit rounded-full border-gray-500"
          />
        ) : (
          <MdOutlineCircle size={18} className="text-gray-500" />
        ),
    },
  ];

  const handleSort = (item) => {
    setSortBy(item);
  };
  const handleRemoveCategory = (categoryToRemove) => {
    setSubCategory(subCategory.filter((filter) => filter !== categoryToRemove));
  };

  const handleClearFilter = () => {
    setSubCategory([]);
    setType("All");
    setBidRange([1000, 100000]);
  };
  const onSearch = (value) => setSearchTerm(value);

  useEffect(() => {
    const bidsCall = async () => {
      try {
        setLoader(true);
        const { data } = await getAllGroupBids(groupID, {
          q: searchTerm,
          subCategory: subCategory,
          bidRange: bidRange,
          sort: sortBy.value,
          page: currentPage,
          limit: limit,
          status: tabFilter,
        });
        console.log(data, 'data');

        if (data?.success) {
          setBids(data?.groupBidList);
          setTotalPages(data?.totalPages);
          setCurrentPage(data?.currentPage);
          setTotalItems(data?.totalItems);
          setLoader(false);
        }
      } catch (error) {
        setLoader(false); // Ensure loader is turned off

        // Default error message
        let errorMessage = 'An unexpected error occurred.';

        // Check if the error has a response and its data
        if (error?.response) {
          // If the error has a response, access status and message safely
          const { status, data } = error.response;

          // Default to the message from the response if it exists, else use a generic message
          errorMessage = data?.message || errorMessage;

          // Handle specific status codes
          if (status === 401) {
            ErrorLogout(error); // Handle 401 Unauthorized, e.g., logout the user
          } else if (status === 403) {
            errorMessage = 'You do not have permission to access this resource.';
          } else if (status >= 500) {
            errorMessage = 'Server error, please try again later.';
          }
        } else if (error?.message) {
          // If the error doesn't have a response, use its message
          errorMessage = error.message;
        }

        // Show error to the user
        message.error(errorMessage);

        // Log the error for debugging
        console.error('API Error:', error);
      }


    };
    bidsCall();
  }, [
    searchTerm,
    sortBy,
    limit,
    currentPage,
    subCategory,
    type,
    bidRange,
    tabFilter,
    trigger,
  ]);

  return (
    <>

      <div className="flex-grow overflow-y-auto scrollbar-hide p-4 lg:p-6 md:p-5">
        <div>
          <div className="lg:sticky top-0 pb-3 lg:z-10 bg-white  ">

            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
              <div className="flex border border-[#9FACF0] p-1.5 gap-1.5 rounded-[12px] w-max bg-white mb-6">
                {tabs.map((tab) => (
                  <button
                    key={tab.value}
                    className={`h-10 px-6 whitespace-nowrap rounded-lg text-sm transition-all duration-200
                  ${activeTab === tab.value
                        ? "bg-white text-[#1955EB] font-semibold shadow-sm border border-blue-100"
                        : "bg-transparent text-gray-500 hover:bg-gray-50 font-medium"
                      }`}
                    onClick={() => {
                      setActiveTab(tab.value);
                      setTabFilter(tab.value);
                      setCurrentPage(1);
                    }}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>


            </div>
          </div>
          <Spin spinning={loader}>
            <div className="pt-[5px]  space-y-10">
              {/* -------------- FILTER------------ */}

              <div className="flex-col lg:flex md:flex lg:space-x-2 ml-auto items-center ">
                <div className="lg:flex items-center gap-3 ">
                  <div>
                    <Search
                      defaultValue={searchValue}
                      placeholder="Search Bids, Category etc..."
                      allowClear
                      onSearch={onSearch}
                      className="w-80 md:w-80 lg:w-80 "
                    />
                  </div>
                  <div className="flex space-x-2 lg:mt-0 md:mt-0 mt-3 items-center">
                    <button className="bg-white flex lg:w-48 md:w-48 text-[14px] lg:text-[16px] md:text-[16px]   gap-1 items-center lg:h-full md:h-10 h-10 rounded-[4px] lg:px-3 md:px-2 px-2 lg:py-[5px] md:py-1  border-[#A3BBFF] font-normal  border-[1px]">
                      <div className="relative inline-block">
                        <div
                          className="flex items-center cursor-pointer lg:px-7 md:px-7 "
                          onClick={() => setIsOpen(!isOpen)}
                        >
                          <img
                            src={sortIcon}
                            alt="Sort Icon"
                            className="mr-2"
                          />
                          Sort By
                          <FaChevronDown
                            className={`ml-2 transition-transform duration-300 ${isOpen ? "transform rotate-180" : ""
                              }`}
                          />
                        </div>
                        {isOpen && (
                          <ul className="absolute lg:left-0  lg:right-0 mt-2 w-48 bg-white border border-gray-200 shadow-lg rounded-md z-10">
                            {sortItems.map((item) => (
                              <li
                                key={item.key}
                                onClick={() => handleSort(item)}
                                className="flex items-center p-2 hover:bg-gray-100 hover:font-medium hover:text-gray-900 cursor-pointer"
                              >
                                <span className="mr-2">{item.icon}</span>
                                <span className="text-sm text-gray-700">
                                  {item.label}
                                </span>
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </button>
                    <div className="flex items-center gap-3 lg:mt-0  md:mt-0">
                      <button
                        className="bg-white flex gap-1 items-center rounded-[4px] text-[14px] lg:text-[16px] md:text-[16px] lg:h-full md:h-10 h-10 lg:px-5 md:px-5 px-3 lg:py-[3px]  border-[#A3BBFF] font-normal  border-[1px]"
                        onClick={() => setIsModalVisible(true)}
                      >
                        <img src={filterIcon} alt="" />
                        Filter
                      </button>
                    </div>
                  </div>

                
                </div>

                {userType === "admin" && (
                  <div>
                    <button className="bg-[#1955EB] text-white px-4 py-2 rounded-md">Create Listings</button>
                  </div>
                )}
              </div>

              {/* {activeTab === 'All' && ( */}
              <div className="flex flex-col  overflow-auto  space-y-4 md:space-y-10">
                {bids.map((item) => (
                  <ProductCard
                    item={item}
                    trigger={trigger}
                    setTrigger={setTrigger}
                    setShowSingleProduct={setShowSingleProduct}
                    setBidID={setBidID}
                  />
                ))}
              </div>
              {/* )} */}
              {/* Pagination Component */}
            </div>
            <div className=" mt-4">
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                limit={limit}
                totalItem={totalItems}
                onPageChange={handlePageChange}
                handleLimit={handleLimit}
              />
            </div>
            <FilterModal
              isVisible={isModalVisible}
              onClose={() => setIsModalVisible(false)}
              setSubCategory={setSubCategory}
              subCategory={subCategory}
              type={type}
              setType={setType}
              bidRange={bidRange}
              setBidRange={setBidRange}
            />
          </Spin>
        </div>
      </div>
    </>
  );
};

export default BidList;
